
import { useMemo } from "react"

import { getContrastTextColor } from "@l2r-front/l2r-utils"

import { EPD_TAG_START_WIDTH } from "../../constants/layout"

import * as Styled from "./EPDTag.styled"

export function EPDTag(props: EPDTagProps) {

    const {
        label,
        color,
        width = EPD_TAG_START_WIDTH,
        direction = "right",
    } = props

    const textColor = useMemo(() => {
        return getContrastTextColor(color)
    }, [color])

    return (
        <>
            {direction === "left" &&
                <Styled.ArrowLeft color={color} width={width}>
                    <Styled.LabelRight variant="Desktop & Mobile/Heading/H2" color={textColor}>{label}</Styled.LabelRight>
                </Styled.ArrowLeft>}
            {direction === "right" &&
                <Styled.ArrowRight color={color} width={width}>
                    <Styled.LabelLeft variant="Desktop & Mobile/Heading/H2" color={textColor}>{label}</Styled.LabelLeft>
                </Styled.ArrowRight>}
        </>
    )
}

type EPDTagProps = {
    label: string
    color: string
    width?: number
    direction?: "left" | "right"
}
